import {
  DEFAULT_PRACTICE_TYPE_CODE,
  mapPayerNameToCodeForDropdown,
} from "constants/practiceType";
import { Label } from "layout/typography/Label";
import { Dropdown } from "primereact/dropdown";
import { Message } from "primereact/message";
import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";

const StyledMessage = styled(Message)`
  justify-content: flex-start;
`;

const GLOBAL_DEFAULT_LABEL =
  mapPayerNameToCodeForDropdown.find(
    (option) => option.value === DEFAULT_PRACTICE_TYPE_CODE
  )?.name ?? "the standard combined service type";

/**
 * CLE-2661 — the account's default pVerify Service Type.
 *
 * This is the question we ask the payer, not a display preference: the practice type selects which
 * benefit blocks come back at all, so it decides which care setting the copay and co-insurance on
 * every new estimate are read from. An account that bills as a surgery centre and asks the broad
 * combined question can be quoted an office copay.
 *
 * "Use the standard default" is a real, distinct value — it stores null so the account tracks the
 * global default rather than freezing today's code into its row.
 */
const options = [
  { name: `Use the standard default (${GLOBAL_DEFAULT_LABEL})`, value: "" },
  ...mapPayerNameToCodeForDropdown,
];

export function Eligibility() {
  const { control } = useFormContext<any>();

  return (
    <div className="flex flex-column gap-3 mt-4">
      <h4 className="m-0">Eligibility</h4>

      <div className="flex flex-column gap-2" style={{ maxWidth: "520px" }}>
        <Label htmlFor="defaultPracticeTypeCode">
          Default Service Type (pVerify practice type)
        </Label>

        <Controller
          control={control}
          name="defaultPracticeTypeCode"
          render={({ field: { onChange, value } }) => (
            <Dropdown
              id="defaultPracticeTypeCode"
              data-testid="defaultPracticeTypeCode"
              optionLabel="name"
              options={options}
              value={value ?? ""}
              onChange={(e) => onChange(e.value === "" ? null : e.value)}
            />
          )}
        />

        <StyledMessage
          severity="info"
          text="Applies to new estimates for this account. Estimates already sent keep the service type they were originally run with."
        />
      </div>
    </div>
  );
}
